import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export default function DonutPanel({ data = [], onCategoryClick, activeCategory }) {
  const total = data.reduce((s, x) => s + (x.value || 0), 0);
  return (
    <div className="panel p-4 flex flex-col" style={{ minHeight: 360 }}>
      <div className="panel-header">
        <div>
          <div className="panel-title">توزيع البلاغات حسب الفئة</div>
          <div className="panel-subtitle mt-0.5">CategoryTier1 من البيانات المستوردة</div>
        </div>
        {onCategoryClick && <span className="pill pill-blue">اضغط للتصفية</span>}
      </div>
      {total === 0 ? (
        <div className="flex-1 flex items-center justify-center text-slate-500 text-sm" style={{ minHeight: 180 }}>لا توجد بيانات</div>
      ) : (
        <div className="flex items-center gap-3 flex-1">
          <div className="relative w-[170px] h-[170px] shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data} innerRadius={55} outerRadius={76} paddingAngle={2.5} dataKey="value" startAngle={90} endAngle={-270}
                  onClick={onCategoryClick ? (e) => onCategoryClick(e?.name || e?.payload?.name) : undefined}
                  style={{ cursor: onCategoryClick ? 'pointer' : 'default' }}>
                  {data.map((e, i) => (
                    <Cell key={i} fill={e.color} stroke={activeCategory === e.name ? '#fff' : 'none'} strokeWidth={activeCategory === e.name ? 2.5 : 0} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <span className="kpi-number text-white text-[26px] leading-none">{total.toLocaleString('en-US')}</span>
              <span className="text-[10.5px] text-slate-400 mt-1 font-semibold">إجمالي البلاغات</span>
            </div>
          </div>
          <ul className="flex-1 space-y-1.5 min-w-0">
            {data.slice(0, 6).map((t) => {
              const isActive = activeCategory === t.name;
              return (
                <li key={t.name}
                  onClick={onCategoryClick ? () => onCategoryClick(t.name) : undefined}
                  className={`flex items-center gap-2 text-[12px] rounded-lg px-2 py-1.5 transition-colors ${onCategoryClick ? 'cursor-pointer hover:bg-white/[0.04]' : ''} ${isActive ? 'bg-white/[0.06] ring-1 ring-white/10' : ''}`}
                  title={t.name}>
                  <span className="w-2.5 h-2.5 rounded-full shrink-0 shadow-sm" style={{ background: t.color, boxShadow: `0 0 8px ${t.color}80` }} />
                  <span className="text-slate-200 flex-1 truncate font-medium">{t.name}</span>
                  <span className="text-white font-bold tabular-nums">{t.value.toLocaleString('en-US')}</span>
                  <span className="text-slate-400 tabular-nums text-[11px]">{t.percent}%</span>
                </li>
              );
            })}
            {data.length > 6 && <li className="text-slate-500 text-[10.5px] px-2">+{data.length - 6} فئات أخرى</li>}
          </ul>
        </div>
      )}
    </div>
  );
}
